<template>
	<!-- <div class="user-account">
		<spinner v-if="user.loading || accounts.loading"/>
		<div class="wrapper" v-else>
			<avatar-picture-user/>
			<div class="info">
				<div class="name">{{ account.name }}</div>
				<change-account />
			</div>
		</div>
	</div> -->
	<div class="user-account">
		<div class="wrapper">
			<avatar-picture-user/>
			<div class="info">
				<div class="info--name">in {{ currentUser.fullname }}</div>
				<div class="info--type">as {{ currentUser.type }}</div>
			</div>
		</div>
		<change-account />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangeAccount from './ChangeAccount'
export default {
	components: {
		ChangeAccount
	},
	computed: {
		/*
		user () {
			return this.$store.state.user
		},
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		accounts () {
			return this.$store.state.accounts
		},
		account () {
			return this.$store.getters.getAccount(this.selectedAccount)
		},
		*/
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style scoped>
.wrapper {
	flex-direction: row;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}
@media screen and (min-width: 481px) and (max-width: 768px) {
	.info {
		display: none;
	}
}
.info {
	text-align: left;
	color: #fff;
	padding: 0 10px;
}
.info--name {
	font-weight: 700;
}
.info--type {
	font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/account/UserAccount.vue